let inject = [
  "$scope",
  "$state",
  "$rootScope",
  "SharedService",
  "ngAuthSettings",
  "$timeout"
];

class CategoriesMenuController {
  constructor(
    $scope,
    $state,
    $rootScope,
    SharedService,
    ngAuthSettings,
    $timeout
  ) {
    this.$state = $state;
    this.$scope = $scope;
    this.ngAuthSettings = ngAuthSettings;
    this.$rootScope = $rootScope;
    this.SharedService = SharedService;
    this.$timeout = $timeout;
    this.activeClass = false;
    this.status = {
      open: false
    };

    this.inOver = false;
  }

  $onInit() {}

  mouseover(id,hijas = null) {
    if(hijas != null){

    if (!this.inOver) {
      var customTimeout = this.$timeout(() => {
        this.activeClass = true;
        this.inOver = true;
        $(".remove-over").removeClass("dropdown-menu--show");
        $("#dropdown-" + id).addClass("dropdown-menu--show");
      }, 600);
    } else if (this.inOver) {
      this.activeClass = true;
      $(".remove-over").removeClass("dropdown-menu--show");
      $("#dropdown-" + id).addClass("dropdown-menu--show");
    }

    $(".alterna-y-ya").mouseleave(() => {
      this.activeClass = false;
      this.inOver = false;
      this.$timeout.cancel(customTimeout);
    });

  }else if(hijas == null){
    this.activeClass = false;
  }else if( (hijas == null) && this.inOver){
    this.activeClass = true;
  }
  }

  mouseleave(id) {
    if (!this.inOver) {
      this.$timeout(() => {
        this.inOver = true;
        $(".remove-over").removeClass("dropdown-menu--show");
        $("#dropdown-" + id).removeClass("dropdown-menu--show");
      }, 600);
    } else if (this.inOver) {
      $(".remove-over").removeClass("dropdown-menu--show");
      $("#dropdown-" + id).removeClass("dropdown-menu--show");
    }
  }

  mouseleave2(){
    this.inOver = false;
    this.activeClass = false;
  }

  clickMenu(id){
    $(".remove-over").removeClass("dropdown-menu--show");
    $("#dropdown-" + id).removeClass("dropdown-menu--show");
  }

}

CategoriesMenuController.$inject = inject;

export default CategoriesMenuController;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/categories-menu/categories-menu.controller.js
 **/